import React from "react";
import { Box, Grid, Button } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import Order from "../Order";

// push order to database
const Orders = () => {
	return (
		<Grid container sx={{ px: 20, py: 10 }}>
			<Grid item md={7} sx={{}}>
				<Box className="menu_bredcrumb">
					<HashLink smooth to="/">
						HOME{" "}
					</HashLink>
					/ ORDER
				</Box>

				<Box>Thank you for shopping with us.</Box>
			</Grid>
		</Grid>
	);
};

export default Orders;
